import api from "../../utils/API";

const getAllSecteursForSelect = () => {
  return api.get(`/societemanagement/secteuractiviteforselect/list`);
};

export {getAllSecteursForSelect};
